import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const GlobalInstructionsModal = ({
  open,
  value = '',
  onChange,
  onClose,
  onSave,
  isSaving = false,
}) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth='md'>
    <DialogTitle sx={{ fontWeight: 700, pr: 6 }}>
      Edit global instructions
      <IconButton onClick={onClose} aria-label='Close' sx={{ position: 'absolute', right: 8, top: 8 }}>
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent sx={{ pt: '12px !important' }}>
      <Typography variant='body2' color='text.secondary' mb={2}>
        These instructions apply across all Company and Product cards. They tell the AI how to
        use client sources together with each card’s own instructions.
      </Typography>
      <TextField
        value={value}
        onChange={(event) => onChange(event.target.value)}
        fullWidth
        multiline
        minRows={10}
      />
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onClose} sx={{ textTransform: 'none' }}>
        Cancel
      </Button>
      <Button variant='contained' onClick={onSave} disabled={isSaving} sx={{ textTransform: 'none' }}>
        {isSaving ? 'Saving…' : 'Save'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default GlobalInstructionsModal;
